const style = (theme) => {
  const transition = `all 1s ${theme.easings['power3.out']}`

  const output = {
    root: {
      transition,
    },
    cover: {
      position: 'relative',
      zIndex: 1,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      '& > a': {
        display: 'block',
      },
    },
    image: {
      position: 'relative',
      width: '100%',
    },
    img: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      fontFamily: "'object-fit: cover;'",
    },
    desc: {
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      fontSize: 28,
      '& a': {
        color: theme.colors[2],
        position: 'relative',
        textTransform: 'uppercase',
        fontWeight: 300,
        lineHeight: 1,
        '&:before': {
          content: '""',
          position: 'absolute',
          zIndex: 1,
          bottom: 5,
          left: 0,
          width: '100%',
          height: 1,
          background: theme.getRgba(theme.colors[2], 0.5),
          transformOrigin: '100% 0',
          transform: 'scaleX(0)',
          transition: 'transform .3s ease-in-out',
          willChange: 'transform',
        },
      },
    },
    designer: {
      marginTop: 5,
      fontSize: 14,
      fontWeight: 300,
      textTransform: 'uppercase',
    },
    price: {
      marginTop: 5,
      fontSize: 14,
      fontWeight: 600,
      textTransform: 'uppercase',
    },
    discountPrice: {
      marginLeft: 10,
      textDecoration: 'line-through',
    },
    cta: {
      marginTop: 20,
      '& > span': {
        fontSize: 12,
        letterSpacing: 1,
        textTransform: 'uppercase',
      },
    },
    hover: {
      '& $title': {
        '& a': {
          '&:before': {
            transformOrigin: '0% 0',
            transform: 'scaleX(1)',
          },
        },
      },
    },
    btnCta: {
      marginRight: 10,
    },
    notAvailable: {
      opacity: 0.4,
      pointerEvents: 'none',
    },
    preorder: {
      fontSize: 11,
      lineHeight: 1.1,
      letterSpacing: 1,
      textTransform: 'uppercase',
      display: 'inline-block',
      padding: '5px 12px',
      background: theme.colors[5],
      borderRadius: 5,
      marginTop: 10,
      alignSelf: 'flex-start',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    title: {
      fontSize: 20,
    },
    preorder: {
      padding: '4px 7px',
      fontSize: 9,
      opacity: 0.9,
      marginTop: 5,
    },
  }

  return output
}

export default style
